<div *ngIf="!loaded && !loadFailed" class="vb-spinner-box vb-spinner-box--inline">
    <vb-spinner size="xl" label="Loading newsletter"></vb-spinner>
</div>

<vb-newsletter-card
    *ngIf="loaded"
    [email]="email"
    [subscribed]="subscribed"
    [pending]="pending"
    [error]="error"
    (toggleSubscription)="onToggleRequested($event)">
</vb-newsletter-card>

<!-- Subscribe/unsubscribe confirm — vb-dialog, same recipe as the
     remove-address confirm in user-addresses. -->
<vb-dialog
    [open]="confirmOpen"
    [tone]="requestedState ? 'neutral' : 'danger'"
    [title]="confirmTitle"
    (closed)="closeConfirm()">
    <p class="newsletter-status__confirm-copy">{{ confirmMessage }}</p>
    <!-- vb-dialog's footer slot stacks children (its full-width recipe);
         a single row wrapper keeps Cancel/Confirm side by side. -->
    <div class="newsletter-status__confirm-actions" dialogFooter>
        <vb-button
            variant="ghost"
            [fullWidth]="true"
            (clicked)="closeConfirm()">
            Cancel
        </vb-button>
        <vb-button
            variant="primary"
            [fullWidth]="true"
            (clicked)="onConfirmed()">
            {{ confirmActionLabel }}
        </vb-button>
    </div>
</vb-dialog>
